import { motion } from "framer-motion";
import { MonitorSmartphone, Check } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { ScreenshotFrame } from "./AppMockup";

const LINES = ["Sebelum Modal Keluar", "Lebih Banyak,", "Pastikan Hitungannya."];

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-white">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-teal-50/80 to-transparent"
      />
      <div className="relative mx-auto grid max-w-6xl items-center gap-10 px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:grid-cols-2 lg:gap-14 lg:px-8 lg:pb-24 lg:pt-20">
        <div>
          <motion.span
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-block rounded-full border border-teal-200/70 bg-teal-50 px-3.5 py-1.5 text-xs font-semibold text-teal-700"
          >
            Untuk kamu yang sedang merintis maupun menjalankan usaha
          </motion.span>
          <h1 className="mt-5 text-3xl font-extrabold leading-[1.15] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            {LINES.map((line, i) => (
              <span key={line} className="block overflow-hidden pb-0.5">
                <motion.span
                  className="block"
                  initial={{ y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{ duration: 0.7, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                >
                  {i === 2 ? (
                    <>
                      Pastikan <span className="text-teal-600">Hitungannya.</span>
                    </>
                  ) : (
                    line
                  )}
                </motion.span>
              </span>
            ))}
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.55 }}
            className="mt-5 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg"
          >
            Mau mulai usaha atau sudah berjualan? KalkuBisnis membantu kamu menghitung HPP,
            menentukan harga jual, memperkirakan BEP, dan mencatat penjualan supaya kamu punya
            gambaran angka usaha yang lebih jelas.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.7 }}
            className="mt-7"
          >
            <CtaButton testid="hero-cta-button" />
            <p className="mt-3 flex items-start gap-1.5 text-xs text-slate-500">
              <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal-600" aria-hidden="true" />
              Bayar satu kali. Tanpa biaya perpanjangan tahunan selama layanan tetap beroperasi.
            </p>
            <p className="mt-2 flex items-center gap-1.5 text-xs text-slate-500">
              <MonitorSmartphone className="h-3.5 w-3.5 shrink-0 text-teal-600" aria-hidden="true" />
              Aplikasi web — akses lewat browser di HP atau komputer.
            </p>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
        >
          <ScreenshotFrame
            src="/screenshots/kalku-hpp.webp"
            alt="Kalkulator HPP KalkuBisnis: rincian bahan baku Es Kopi Susu Gula Aren, HPP per unit Rp7.360, dan rekomendasi harga jual Rp12.512"
            width={1372}
            height={897}
            testid="hero-app-mockup"
            eager
          />
        </motion.div>
      </div>
    </section>
  );
}
